import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig } from '../../models/base-api-config.model';

export type BrandingApiConfig = BaseApiConfig<{
  getBranding: string;
  updateBranding: string;
  getLogoUploadUrl: string;
}>;

export const BRANDING_API_CONFIG = new InjectionToken<BrandingApiConfig>('BRANDING_API_CONFIG');

export const provideBrandingApiConfig = (config: BrandingApiConfig): StaticProvider => ({
  provide: BRANDING_API_CONFIG,
  useValue: config,
});
